/* Bernard James PLP product/category carousel.
   Reuses the theme's global Swiper bundle (loaded deferred in theme.liquid). */
(function () {
	function initCarousels(scope) {
		if (typeof Swiper === "undefined") return;

		(scope || document)
			.querySelectorAll(".js-plp-carousel")
			.forEach(function (root) {
				if (root.dataset.plpCarouselReady === "true") return;

				var container = root.querySelector(".plp-carousel__swiper");
				if (!container) return;

				var itemsDesktop = parseInt(root.dataset.itemsDesktop, 10) || 6;

				new Swiper(container, {
					slidesPerView: 3,
					spaceBetween: 4,
					watchOverflow: true,
					navigation: {
						prevEl: root.querySelector(".js-plp-carousel-prev"),
						nextEl: root.querySelector(".js-plp-carousel-next"),
					},
					breakpoints: {
						750: { slidesPerView: 4, spaceBetween: 4 },
						990: { slidesPerView: itemsDesktop, spaceBetween: 4 },
					},
				});

				root.dataset.plpCarouselReady = "true";
			});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", function () {
			initCarousels(document);
		});
	} else {
		initCarousels(document);
	}

	document.addEventListener("shopify:section:load", function (event) {
		initCarousels(event.target);
	});
})();
